import React, { Component } from "react";
import crypto from "crypto";
import data from "./api";
import { store } from "react-notifications-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";

const {
  listenForUserData,
  generateQrCodeNest,
  registerVendor,
} = data;

class LoginAge extends Component {
  state = {
    showSpinner: false,
    qrcode: false,
    response: false,
    showModal: false, // Controls modal visibility
    qrCodeData: "",
  };

  componentDidMount = async () => {
    if (localStorage.email != null) {
      this.setState({ loggedIn: true });
    }
  };

  openModal = () => {
    this.setState({ showModal: true });

    setTimeout(() => {
      const modalElement = document.getElementById("exampleModalKyc");
      if (modalElement) {
        const modalInstance = new window.bootstrap.Modal(modalElement);
        modalInstance.show();
      }
    }, 0);
  };

  closeModal = () => {
    this.setState({ showModal: false });

    setTimeout(() => {
      const modalElement = document.getElementById("exampleModalKyc");
      if (modalElement) {
        const modalInstance = new window.bootstrap.Modal(modalElement);
        modalInstance.hide();
      }

      // Remove Bootstrap modal backdrop
      const modalBackdrop = document.querySelector(".modal-backdrop");
      if (modalBackdrop) {
        modalBackdrop.remove();
      }

      document.body.classList.remove("modal-open");
    }, 0);
  };

  listenForSocket = () => {
    listenForUserData(async (err, res) => {
      let bytes = res.userDetails || res.newreq;
      sessionStorage.setItem("profileData", JSON.stringify(bytes));

      if (bytes === "denied" || bytes.permission === "denied") {
        this.closeModal();
      } else {
        this.setState({ response: true, showSpinner: false, loggedIn: true });
        if (bytes.permission === "granted") {
          this.adminNotificationState();
      } 
        this.closeModal();
      }
    });
  };

  adminNotificationState = () => {
    this.redirectToAdmin();
  };

  redirectToAdmin() {
    window.location.href = "/request-proofOfAge";
  }

  QrCodeDataSDD = () => {
    registerVendor()
      .then((d) => {
        const timestamp = Date.now();
        const hash = crypto
          .createHmac("sha256", d.secretKey)
          .update(JSON.stringify(d.apiKey + "Rejolut@1008" + timestamp))
          .digest("hex");

        generateQrCodeNest(hash, d.apiKey, "Rejolut@1008", timestamp, "login")
          .then((data) => {
            this.listenForSocket();
            this.setState({ qrCodeData: data });
            this.openModal(); // Open modal when QR is generated
            this.props.onComplete();
          })
          .catch((err) => alert(err));
      })
      .catch((err) => alert(err));
  };


  render() {
    return (
      <>
        {/* 🔹 Button to trigger modal */}
        <div >
          <button
            type="button"
            className="kycBtn"
            onClick={this.QrCodeDataSDD}
            // style={{
            //   padding: "7px 10px",
            //   width: "140px",
            //   backgroundColor: "#fff",
            //   color: "#80a1c1",
            //   border: "2px solid #80a1c1",
            //   borderRadius: "5px",
            //   cursor: "pointer",
            //   fontSize: "16px",
            // }}
          >
            Request
          </button>
        </div>

        {/* 🔹 Bootstrap Styled Modal */}
        <div className="modal fade" id="exampleModalKyc" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div className="modal-dialog" role="document">
            {this.state.showModal && (
              <div className="modal-content">
                {/* 🔹 Modal Header */}
                <div className="close-button-containerr">
                  <h4 style={{ color: "black" }}>Scan with EarthID Wallet</h4>
                  <FontAwesomeIcon
                    className="close-buttonn"
                    data-dismiss="modal"
                    icon={faClose}
                    onClick={this.closeModal}
                  />
                </div>

                {/* 🔹 Modal Body */}
                <div className="modal-body">
                  <div className="pop-upbox">
                    {this.state.showSpinner && (
                      <div className="spinner-div">
                        <img className="spinner" src={require("./spinner.gif")} alt="Loading..." />
                      </div>
                    )}

                    {this.state.qrCodeData ? (
                      <div className="qr-container" style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
                        <img src={this.state.qrCodeData} alt="QR Code"  />
                      </div>
                    ) : (
                      <p style={{ textAlign: "center", color: "#888", fontSize: "14px" }}>Loading QR...</p>
                    )}

                    {/* 🔹 Add Manually Button */}
                    
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </>
    );
  }
}

export default LoginAge;
